module.exports = __webpack_public_path__ + "static/media/success-img.bf31af77.png";